export default {
  counter: {
    our_impact: "OUR IMPACT",
    trusted_by: "Trusted by",
    growing_businesses: "Growing Businesses",

    happy_restaurants: "Happy Restaurants",
    verified_suppliers: "Verified Suppliers",
    industry_awards: "Industry Awards",
    average_rating: "Average Rating",
  },
};